(function () {
  var SELECTORS = [
    '.menu-drawer__navigation-container',
    '.menu-drawer__inner-submenu'
  ];

  function isSlideVisible(el) {
    var sub = el.closest('.menu-drawer__slide--sub');
    if (sub) return sub.classList.contains('is-active');
    var main = el.closest('.menu-drawer__slide--main');
    if (main) return !main.classList.contains('is-hidden');
    return true;
  }

  function buildScrollbar() {
    var track = document.createElement('div');
    track.className = 'menu-drawer__scrollbar';
    var thumb = document.createElement('div');
    thumb.className = 'menu-drawer__scrollbar-thumb';
    track.appendChild(thumb);
    document.body.appendChild(track);
    return { track: track, thumb: thumb };
  }

  function updateScrollbar(el, track, thumb) {
    var scrollHeight = el.scrollHeight;
    var clientHeight = el.clientHeight;

    if (scrollHeight <= clientHeight || !isSlideVisible(el)) {
      track.style.display = 'none';
      return;
    }

    var style = getComputedStyle(el);
    var paddingTop = parseFloat(style.paddingTop) || 0;
    var paddingBottom = parseFloat(style.paddingBottom) || 0;
    var trackHeight = clientHeight - paddingTop - paddingBottom;
    var rect = el.getBoundingClientRect();

    track.style.display = 'block';
    track.style.top = (rect.top + paddingTop) + 'px';
    track.style.height = trackHeight + 'px';

    var thumbHeight = Math.max(24, (clientHeight / scrollHeight) * trackHeight);
    var thumbTop = (el.scrollTop / (scrollHeight - clientHeight)) * (trackHeight - thumbHeight);

    thumb.style.height = thumbHeight + 'px';
    thumb.style.top = thumbTop + 'px';
  }

  function initScrollbar(el) {
    if (el.dataset.scrollbarInit) return;
    el.dataset.scrollbarInit = '1';

    var _build = buildScrollbar();
    var track = _build.track;
    var thumb = _build.thumb;

    new ResizeObserver(function () {
      updateScrollbar(el, track, thumb);
    }).observe(el);

    el.addEventListener('scroll', function () {
      updateScrollbar(el, track, thumb);
    }, { passive: true });

    el._scrollbarState = { track: track, thumb: thumb };
    updateScrollbar(el, track, thumb);
  }

  function initAll() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(initScrollbar);
    });
  }

  function updateAll() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var s = el._scrollbarState;
        if (s) updateScrollbar(el, s.track, s.thumb);
      });
    });
  }

  function hideAll() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var s = el._scrollbarState;
        if (s) s.track.style.display = 'none';
      });
    });
  }

  var details = document.querySelector('header-drawer details');
  if (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        initAll();
        updateAll();
      } else {
        hideAll();
      }
    });
  }

  var drawer = document.querySelector('.menu-drawer');
  if (drawer) {
    new MutationObserver(updateAll).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
